<template>
  <div>
    <template v-if="!(channelConnected)">
      <v-progress-circular
        indeterminate
        color="blue"
        size="22"
      ></v-progress-circular>
    </template>
    <template v-else>
      <v-menu bottom offset-y left>
          <v-btn slot="activator" flat small icon>
              <v-badge right :color="colorNotification" overlap :value="notifications.length > 0 ? true : false">
              <span slot="badge">{{ notifications.length }}</span>
              <v-icon>mdi-bell-outline</v-icon>
              </v-badge>
          </v-btn>
        <v-list three-line dense subheader class="notifications pb-0">
          <v-subheader class="notifications-title secondary">
            <span>Notificações</span>
            <a v-if="notifications" class="blue--text" @click.stop="markAllAsRead()">Marcar todas como lidas</a>
          </v-subheader>
          <v-list-tile v-if="!notifications || notifications.length === 0">
            <v-list-tile-title class="text-xs-center">Sem notificações</v-list-tile-title>
          </v-list-tile>
          <v-layout column v-for="notification in firstNotifications" :key="notification.id">
            <v-list-tile avatar>
              <v-list-tile-avatar v-if="notification.user">
                <v-img
                  :src="notification.user.picture_url"
                  contain
                />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  <div class="d-flex justify-space-between" >
                    <div class="text-truncate">
                      <strong v-if="notification.user">{{ reducedName(notification.user.name) }}</strong> {{ notification.title }}
                    </div>
                    <div class="text-xs-right time">
                      <span>{{ formatDate(notification.created_at) }}</span>
                      <v-tooltip right class="ml-2">
                        <v-icon
                          size="16"
                          color="grey"
                          @click.stop="markNotificationAsRead(notification.id)"
                          slot="activator"
                        >
                          mdi-close-circle-outline
                        </v-icon>
                        <span>Marcar como lido</span>
                      </v-tooltip>
                    </div>
                  </div>
                </v-list-tile-title>
                <v-list-tile-action-text v-if="notification.document  && notification.folder" class="d-flex align-center">
                    <v-icon color="blue">mdi-file</v-icon>
                    <a class="blue--text ml-1" @click.stop="showDocument(notification.folder,notification.document)"><strong>{{ notification.document.type }}</strong></a>
                </v-list-tile-action-text>
                <v-list-tile-sub-title v-if="notification.folder">
                  <div class="d-flex align-center">
                    <v-icon color="amber" class="custom-folder-icon">mdi-folder-open</v-icon>
                    <a class="blue--text ml-1" @click.stop="openFolder(notification.folder.id)"><strong>{{ notification.folder.process_number }}</strong></a>
                  </div>
              </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>
          </v-layout>
        </v-list>
        <v-list class="notifications-footer pa-0" v-if="notifications.length > numberNotifications">
          <v-btn class="blue--text text-capitalize" small flat @click.stop="seeAllNotifications()">Ver mais</v-btn>
        </v-list>
      </v-menu>
    </template>
  </div>
</template>

<script>
import format from 'date-fns/format';
import { pt } from 'date-fns/locale/pt';
import { orderBy } from 'lodash';
import WEBSOCKET_URL from '@/constants/WEBSOCKET_URL';
import bus from '@/utils/event-bus';
import { Socket } from './../../phoenix';

export default {
  name: 'user-notifications',
  data() {
    return {
      // notifications,
      notifications: [],
      socket: null,
      socket_url: WEBSOCKET_URL(),
      channel: null,
      numberNotifications: 3,
      colorNotification: 'blue',
      channelConnected: false,
    };
  },
  mounted() {
    // this.socket = new Socket(this.socket_url, { params: { token: localStorage.getItem('access_token') } });
    // this.socket.connect();
    //
    // this.channel = this.socket.channel(`user:${JSON.parse(localStorage.getItem('user')).id}`);
    //
    // this.socket.onError(() => { this.channelConnected = false; });
    // this.socket.onClose(() => { this.channelConnected = false; });
    // this.channel.onError(() => { this.channelConnected = false; });
    // this.channel.onClose(() => { this.channelConnected = false; });
    //
    // this.channel.on('new_notification', (payload) => {
    //   this.newNotification(payload.data);
    // });
    //
    // this.channel
    //   .join()
    //   .receive('ok', (response) => {
    //     this.notifications = [];
    //     response.data.forEach(n => this.newNotification(n, false));
    //     this.channelConnected = true;
    //   })
    //   .receive('error', ({ reason }) => console.log('failed join', reason)) // eslint-disable-line
    //   .receive('timeout', () => console.log('Networking issue. Still waiting...')); // eslint-disable-line
  },
  methods: {
    markAllAsRead() {
      this.channel.push('read_all_notifications')
        .receive('ok', () => {
          this.notifications = [];
        });
    },
    markNotificationAsRead(id) {
      this.channel.push('read_notification', { notification_id: id })
        .receive('ok', () => {
          this.notifications = this.notifications.filter(item => item.id !== id);
        });
    },
    seeAllNotifications() {
      // mostrar todas as notificações
      this.numberNotifications += 2;
    },
    formatDate(date) {
      return format(date, 'HH:mm', { locale: pt });
    },
    changeNotificationMarkIcon(idx, icon) {
      return icon;
    },
    newNotification(notification, alert = true) {
      if (alert) {
        let messageNotification = 'Você tem uma nova notificação!';
        if (notification.category === 'transact_folder_to_user' ||
          notification.category === 'transact_folder_to_administrative_unit') {
          messageNotification = 'Você tem um novo Processo!';
          const audio = new Audio('http://soundbible.com/mp3/Elevator Ding-SoundBible.com-685385892.mp3');
          audio.play();
          bus.$emit('loadInboxFolder');
        }

        this.$store.dispatch('toggleSnackbar', {
          show: true,
          color: 'blue',
          message: messageNotification,
          button: { show: true, text: 'Fechar', message: '' },
          timeout: 5000,
        });
        // this.colorNotification = 'red';
        // setInterval(() => {
        //   this.colorNotification = 'blue';
        // }, 2000);
      }
      this.notifications.push(this.buildNotification(notification));
      this.notifications = orderBy(this.notifications, ['id'], ['desc']);
    },
    buildNotification(notification) {
      return {
        created_at: notification.date,
        id: notification.id,
        document: notification.attachment.document,
        folder: notification.attachment.folder,
        user: notification.attachment.sender,
        title: notification.body,
      };
    },
    reducedName(name) {
      const split = name.split(' ');
      return `${split[0]} ${split[split.length - 1]}`;
    },
    openFolder(id) {
      const route = this.$router.resolve(`/pastas/${id}/show`);
      window.open(route.href, '_blank');
    },
    showDocument(folder, document) {
      const route = this.$router.resolve({
        path: `/pastas/${folder.id}/show`,
        query: { documentId: document.id },
      });
      window.open(route.href, '_blank');
    },
  },
  computed: {
    firstNotifications() {
      return this.notifications.slice(0, this.numberNotifications);
    },
  },
};
</script>

<style lang="scss" scoped>
  .notifications {
    width: 480px;
    overflow-y: auto;
  }
  .notifications-title {
    display: flex;
    justify-content: space-between;
  }
  .notifications-footer {
    width: 100%;
    text-align: center;
    background: #fff;
  }
  .custom-folder-icon::after {
    content: '';
    margin-top: -7px;
    margin-left: -10px;
    padding: 4px;
    background-color: #ffc107;
    border-radius: 50%;
    border: 2px solid white;
  }
  .time {
    flex: 0;
    align-items: flex-end;
  }
</style>



// WEBPACK FOOTER //
// src/components/user-toolbar/UserNotifications.vue